import * as React from "react";
import { motion } from "framer-motion";
import { Grid, CardMedia } from "@mui/material";
import PodcastsIcon from "@mui/icons-material/Podcasts";
import { PrincipaleButton } from "../PrincipaleButton";

import FirstImage from "../../images/6048753.jpg";

import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { useTranslation } from "react-i18next";
import enTranslations from "../../en.json";
import arTranslations from "../../ar.json";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: enTranslations },
    ar: { translation: arTranslations },
  },
  lng: "en",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

const PodcastSection = () => {
  const { t } = useTranslation();
  const isArabic = i18n.language === "ar";
  return (
    <motion.section
      className="about overflow-hidden py-5"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 2 }}
    >
      <div className="row w-100">
        <div className="row col-md-11 mx-auto ">
          <div className="col-md-6 img">
            <motion.img
              src={FirstImage}
              alt=""
              className="img-fluid"
              initial={{ x: -200, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ duration: 2 }}
            />
          </div>
          <div className="col-md-6 ps-2">
            <motion.p
              className="miniTitle"
              initial={{ x: 200, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ duration: 2 }}
            >
              {t("join")}{" "}
              {isArabic ? null : (
                <span className="headerHighlight">FINANCEBDARIJA</span>
              )}{" "}
              {t("joinourpodcasts")}
            </motion.p>
            <motion.h1
              className="headerTitle"
              initial={{ x: -200, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ duration: 2 }}
            >
              {t("achievingyour")}{" "}
              {isArabic ? null : (
                <span className="headerHighlight">FINANCIAL</span>
              )}{" "}
              {t("goal")}
            </motion.h1>
            <motion.p
              className="headerContent"
              initial={{ x: 200, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ duration: 2 }}
            >
              {t("paragraph1")}
            </motion.p>
            <PrincipaleButton
              startIcon={<PodcastsIcon />}
              variant="contained"
              href="/signup"
            >
              {t("subscribe")}
            </PrincipaleButton>
          </div>
        </div>
      </div>
    </motion.section>
  );
};

export default PodcastSection;
